export enum SW_WORKER_MESSAGE {
    VERSION_READY = 'VERSION_READY'
}